/**
 * Xero Duplicate Closure Bills Report
 *
 * Detects duplicate COGS bills and sales invoices from register closures.
 * Each row shows the suspected original alongside one suspected duplicate,
 * with totals for both so users can compare and confirm.
 */
import BaseReportPage, { ColumnDef } from './BaseReportPage'

const columns: ColumnDef[] = [
  { key: 'fp_code', label: 'FP Code' },
  { key: 'franchise_name', label: 'Franchise' },
  { key: 'last_sync_at', label: 'Data Age', type: 'sync_status' },
  { key: 'fp_status', label: 'Status' },
  { key: 'type_label', label: 'Type', filterable: true },
  { key: 'closure_date', label: 'Closure Date', type: 'date' },
  { key: 'contact_name', label: 'Contact', link: { field: 'xero_contact_link', system: 'xero' } },
  { key: 'register_name', label: 'LS Register', link: { field: 'register_closure_link', system: 'lightspeed' } },
  { key: 'reference', label: 'Reference' },
  { key: 'original_number', label: 'Original #', link: { field: 'original_link', system: 'xero' } },
  { key: 'original_total', label: 'Original Total', type: 'currency' },
  { key: 'duplicate_number', label: 'Duplicate #', link: { field: 'duplicate_link', system: 'xero' } },
  { key: 'duplicate_total', label: 'Duplicate Total', type: 'currency' },
  { key: 'line_items_match', label: 'Line Items Match', filterable: true },
  { key: 'line_item_summary', label: 'Line Item Summary' },
]

export default function XeroDuplicateClosureBillsReport() {
  return (
    <BaseReportPage
      reportType="xero_duplicate_closure_bills"
      title="Xero Duplicate Closure Bills"
      description="Detect duplicate COGS bills and sales invoices from register closures."
      filterConfig={{
        showFpSelector: true,
        showFpStatus: true,
        showCountry: true,
        showRegion: true,
        showDateRange: true,
        defaultDateRange: 'last_30_days',
        linkFpStatusToSearch: true,
      }}
      columns={columns}
      defaultSortColumn="closure_date"
      defaultSortDirection="desc"
    />
  )
}
